<template >
 <v-dialog v-model="show_dialog" :max-width="width">
  <v-card>
    <v-card-title primary-title class="headline info lighten-2">
    	<h2>商品报损</h2>
    </v-card-title>
    <v-card-text>
      <v-form>     
        <v-layout row wrap>
            报损原因
          <v-flex xs12 sm12 md12>
            <v-radio-group v-model="why" :mandatory="false">
                <v-layout row>
                    <v-flex xs6 sm6 md6>
                          <v-radio label="过期" value="timeout"></v-radio>
                          <v-radio label="损坏" value="breakdown"></v-radio>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                          <v-radio label="退货" value="back"></v-radio>
                          <v-radio label="其它" value="else"></v-radio>
                    </v-flex>
                </v-layout>
              
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <v-text-field
                label  ="备注"
                v-model="node"
                :error ="!node"
                required>
            </v-text-field>
          </v-flex>
        </v-layout>

      </v-form>
    </v-card-text>
    
    <v-card-actions>
    	<v-spacer></v-spacer>
      <v-btn class="btn-" @click.stop="show_dialog=false">取消</v-btn>
      <v-btn
	      :loading="creating"
	      :disabled="creating||!(why&&node)"
	      color="info"
	      @click.native.stop="create_record">
	      确定
	      <span slot="loader" class="custom-loader">
	        Loading...
	      </span>
	  </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>       
        
   
</template>

<script>
import {base_api} from "@/api/base_api"   
// import { mapGetters,mapMutations } from 'vuex'

export default {
    //template:``,
    name: '',
    props:{
    	width:{
    		type:String,
    		default:'500px'
    	}
    },

    computed:{
        prodcuts_list(){
            return this.$store.state.products;
        },
    	show_dialog:{
	      get(){
	          return this.$store.state.dialog.show_destroy_dialog;
	      },
	      set(val){
            this.$store.commit('SHOW_DIALOG_DESTROY',val)//destroy
	      }
	    }
    },
    methods:{
    	init_value(){
            this.creating = false;
            this.node     = '';
            this.why      = 'else';
    	},
    	create_record(){
    		console.log("click")
            let self = this;
            if(self.prodcuts_list.list.length == 0){
                return self.$notify({
                        group: 'msgpad',
                        type: 'warn',
                        title: '操作失败！',
                        text: '无待操作商品'
                })
            }
            self.creating = true;
            base_api({
                schema:'ship.php',
                method:'post',
                params:{oper:'destroy'},//self.show_dialog
                data:{
                    order_id :self.prodcuts_list.order_id,
                    node     :self.node,
                    why      :self.why,
                    items    :self.prodcuts_list.list.map(it=>{return {
                        gid     :it.gid,
                        info    :it.name,
                        num     :it.num,
                        incount :0
                    }})
                }
            }).then(doc=>{
                self.$store.commit('PAYINFO_SETTING',{pay_status:1,'title':"报损成功"})
				self.$notify({
                    group : 'msgpad',
                    type  : 'success',
                    title : '操作成功！',
                    text  : '报损成功',
			        duration: 500,
			    })
			    self.show_dialog = false;
			}).catch(err=>{
				self.$notify({
			        group: 'msgpad',
			        type: 'warn',
			        title: '操作失败！',
			        text: '记录创建失败'+   (err.response&&err.response.data)? err.response.data: err.message
			    })
			}).then(_=>{
				self.creating = false;
			})
    	}
    },
    components:{},
    watch:{
        show_dialog(val){
            if(val){
                this.init_value();
            }
        }
    },
    directives: {},
    mounted :function(){},
    data () {
      return {
      	creating:false,
        node:'',
        why:null,
        node:""
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/front_sale/dialogs/dialog_destroy.vue